import { ApiCore } from "@/services/api/utils/core.js";
import axios from "axios";
import { handleResponse, handleError } from "@/services/api/utils/response.js";
import { apiProvider } from "@/services/api/utils/provider.js";

const url = `network`;

const api = new ApiCore({
	index: true,
	findOne: false,
	findAll: false,
	create: false,
	update: false,
	remove: false,
	url: url,
});

export default api;
